import React, { useEffect, useState } from 'react';
import Fetch from '../../../functions/Fetch';
import config from '../../../../../../config/config';
import '../ReportStyle.css';
import ExportButtons from '../ExportButtons';
import moment from 'moment';
import * as XLSX from 'xlsx'
import { formatCurrency } from '../../../../../../helpers/pcontas';

const DirdExpense = (props) => {
    const [items, setItems] = useState([]);

    const startDate = moment(props.filters.startDate).format('DD/MM/YYYY');
    const endDate = moment(props.filters.endDate).format('DD/MM/YYYY');

    useEffect(() => {
        const fetchData = async () => {
            const response = await Fetch.post(config.endpoints.backend + 'portal/getreport', props.filters);
            setItems(response); 
        }

        fetchData();
    }, [props.filters])

    function dataForSheet(){
        const table = document.getElementById('table_dird_expense');
        const resumeTable = document.getElementById('resume_dird_expense');
        const conciliationTable = document.getElementById('conciliation_dird_expense');

        const dataTable = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(table, {raw: true}), { header: 1, raw: true });
        const resumeData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(resumeTable, {raw: true}), { header: 1, raw: true });
        const conciliationData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(conciliationTable, {raw: true}), { header: 1, raw: true });

        return {dataTable, resumeData, conciliationData}
    }

    function dataForCsv() {
        const table = document.getElementById('table_dird_expense');
        const resumeTable = document.getElementById('resume_dird_expense');
        const conciliationTable = document.getElementById('conciliation_dird_expense');
    
        if (!table || !resumeTable || !conciliationTable) {
            console.error("Uma ou mais tabelas não foram encontradas.");
            return [];
        }
    
        const dataTable = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(table, {raw: true}), { header: 1, raw: true });
        const resumeData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(resumeTable, {raw: true}), { header: 1, raw: true });
        const conciliationData = XLSX.utils.sheet_to_json(XLSX.utils.table_to_sheet(conciliationTable, {raw: true}), { header: 1, raw: true });

        let combinedData = [];

        combinedData = combinedData.concat(dataTable);
        combinedData.push([]);
    
        combinedData = combinedData.concat(resumeData);
        combinedData.push([]);
    
        combinedData = combinedData.concat(conciliationData);

        return combinedData
    }

    function dataForJson(){
        let principalReport = {};
        let dirdConciliationReport = {};
        let othersValues = {};
        const headers = items.reports.headers;
        headers.shift();
        const rows = items.reports.rows;
        headers.forEach((header, indexHeader) => {
            principalReport[header] = {};
            rows.forEach((row, index) => {
                principalReport[header][row] = items.reports[header][row];
            })
        })

        for (const element of items.reports.dirdConciliation) {
            dirdConciliationReport[element.header] = element.value;
        }
        
        for (const element of items.reports.othersValues) {
            othersValues[element.header] = element.value;
        }

        return {
            principalReport,
            dirdConciliationReport,
            othersValues
        };
    }

    function dataForTXT(){
        const table = document.getElementById('table_dird_expense');
        let txtContent = '';

        function padString(str, length) {
            return str.padEnd(length, ' ');
        }

        const colSizes = [15,50,140,80,80,50,50,50,50];

        for (let row of table.rows) {
            let rowData = [];
            let countCell = 0;
            for (let cell of row.cells) {
                rowData.push(padString(cell.innerText, 80));
                countCell++;
            }
            txtContent += rowData.join(' ') + '\n';
        }

        return txtContent;
    }

    return (
            <div>
                {items.reports && (
                    <div className='containerDird'>  
                        <div className='row info-filters'>
                            <div className='col-12'>
                                <p>Projeto: <b>{items.reports.pdcProject.project_name}</b></p>
                            </div>
                            <div className='col-12'>
                                <p>Origem dos Recursos: <b>{items.reports.originResourceName}</b></p>
                            </div>
                            <div className='col-12'>
                                <p>Período Selecionado: <b>{startDate} até {endDate}</b></p>
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <ExportButtons 
                                jsonData={dataForJson} 
                                sheetData={dataForSheet} 
                                csvData={dataForCsv}  
                                pdfAttributes={{
                                    ids: ['table_dird_expense', 'resume_dird_expense', 'conciliation_dird_expense'],
                                    styles: {
                                        table_dird_expense: {
                                            columnStyles: {
                                                1: { cellWidth: 30 },
                                                2: { cellWidth: 30 },
                                                3: { cellWidth: 30 },
                                                4: { cellWidth: 30 },
                                                5: { cellWidth: 30 }
                                            }
                                        }
                                    }
                                }} 
                                txtAttributes={{
                                    table_dird_expense: {
                                        colSizes: [80]
                                    },
                                    resume_dird_expense: {
                                        colSizes: [80]
                                    },
                                    conciliation_dird_expense: {
                                        colSizes: [80]
                                    }
                                }}
                            />
                        </div>
                        <div id="teste" className='row'>
                            <table className="table table-dird tables-report" id="table_dird_expense" cellPadding={5} cellSpacing={0}>
                                <thead className="text-center">
                                    <tr>
                                    <th colSpan={6}>DEMONSTRATIVO DAS DESPESAS INCORRIDAS NO EXERCÍCIO</th>
                                    </tr>
                                    <tr>
                                    {Object.keys(items.reports.demonstrativeReport[0]).map((header, index) => (
                                        <th key={index} style={{ maxWidth: '200px' }}>{header}</th>
                                    ))}
                                    </tr>
                                </thead>

                                <tbody className="tbody-dird">
                                    {items.reports.demonstrativeReport.map((row, rowIndex) => (
                                    <tr key={rowIndex} className={row['Categoria ou Finalidade das Despesas'] === 'TOTAL' ? 'font-weight-bold' : ''}>
                                        {Object.keys(row).map((key, colIndex) => (
                                        <td key={colIndex} className={colIndex === 0 ? '' : 'tdValue'}>
                                            {colIndex === 0 ? row[key] : formatCurrency(row[key])}
                                        </td>
                                        ))}
                                    </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>

                        <div class="extra-div">
                            <table className='table table-extra tables-report mt-4' id='resume_dird_expense'>
                                <thead>
                                    <tr>
                                        <th className='text-center bold-text' colSpan={2}>
                                            RELATÓRIO DE DESPESAS COM MULTAS, JUROS, FRETES, E OUTRAS DESPESAS
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className='text-center bold-text' colSpan={2}>
                                            CONSTATAMOS NO PERÍODO O PAGAMENTO DE DESPESAS NÃO PREVISTAS CONFORME A SEGUIR:
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.reports.othersValues.map((item, index) => {
                                        if(item.header !== "Sub Total"){    
                                            return (
                                                <tr>
                                                    <td style={{width: '50rem'}}>{item.header}</td>
                                                    <td className='tdValue'>{formatCurrency(item.value)}</td>
                                                </tr>
                                            )
                                        }
                                    })}
                                    <tr><td colSpan={2}></td></tr>
                                    <tr>
                                        <td>Sub Total</td>
                                        <td className='tdValue'>{formatCurrency(items.reports.othersValues.find(item => item.header === "Sub Total").value)}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className='table tables-report mt-4' id='conciliation_dird_expense'>
                                <thead>
                                    <tr><th colSpan={2} className='text-center bold-text'>CONCILIAÇÃO DIRD</th></tr>
                                </thead>
                                <tbody>
                                    {items.reports.dirdConciliation.map((item, index) => (
                                            <tr>
                                                <td style={{width: '50rem'}}>{item.header}</td>
                                                <td className='tdValue'>{formatCurrency(item.value)}</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>

                        </div>

                    </div>
                )}
            </div>
    );
};
    
export default DirdExpense;
    